export default "__VITE_ASSET__9VhG2Nxb__"